import { PaymentSystemName } from '../../payments/service/paymentSettings.interface';

export interface ShopProps {
    type: number;
    name: string;
    id: number;
    shop_link: string;
    shop_inline: string;
    readonly buyable: boolean;
    readonly photo: string | File | null;
    readonly about: string;
    readonly price_from: boolean;

    details: {
        contact_info: string;
        config: string;
        integration_email: string;
        policy?: string | null;
        offer?: string | null;
    };

    payment_system?: PaymentSystemName | null;

    legal_info: ShopLegalInfo | null;
}

export interface Shop {
    name?: string | null;
    limit: number;
    offset: number;
}

export interface ShopValues extends ShopKeys {
    readonly shop_id?: number;
    readonly name: string;
    readonly about: string;
    readonly buyable: boolean;
    readonly photo: string | File | null;
    readonly price_from: boolean;
    readonly photo_url?: string;
    readonly type?: number;
    create_type: string;
    feed_url: string;
    api_key: string;
    client_id: string;
}

export interface ShopKeys {
    project_id?: number;
    secretKey?: string;
}

export enum ShopOrderType {
    pay = 'Покупка',
    preorder = 'Предзаказ',
}

export enum ShopDetailsType {
    contactInfo = 3,
    config = 4,
    integrationEmail = 5,
}

export interface ShopDetailsProps {
    readonly id?: number;
    readonly body: {
        type: ShopDetailsType;
        value: string;
    };
}

export interface ShopState
    extends Pick<
        ShopValues,
        'name' | 'about' | 'buyable' | 'photo' | 'price_from'
    > {
    id: number | null;
    user_id?: number | null;
    shop_inline: string;
    shop_link: string;
    payment_system?: string | null;
    details: {
        contact_info: string;
        config: string;
        integration_email: string;
        policy?: string | null;
        offer?: string | null;
    };
    list?: ShopProps[];
    type: number;
    legal_info: ShopLegalInfo | null;
    current?: ShopProps | null;
}

interface ShopLegalInfo {
    additionally: null | string;
    address: string;
    email: string;
    id: number;
    inn: string;
    kpp: string;
    name: string;
    ogrn: string;
    phone: string;
    user_id: number;
}
